import type { userDataApi } from '@/entities/user-data'

import { type ErrorResponse, postRequest } from '@/shared/api'

import type { AddCarResponse } from './types'

import { ADD_CAR, DELETE_CAR } from './constants'

export function addCar(payload: Omit<userDataApi.Grn, 'id'>) {
    return postRequest<AddCarResponse, ErrorResponse>(`${ADD_CAR}`, payload)
}

export function deleteCar(id: number) {
    return postRequest<unknown, ErrorResponse>(`${DELETE_CAR}`, {
        car_id: id,
    })
}
